export const RESET_OFFICIAL_STATE = 'RESET_OFFICIAL_STATE';
export const GET_OFFICIAL_KINDERGARTENS = 'GET_OFFICIAL_KINDERGARTENS';
export const SET_OFFICIAL_KINDERGARTENS = 'SET_OFFICIAL_KINDERGARTENS';
export const SET_OFFICIAL_KINDERGARTEN = 'SET_OFFICIAL_KINDERGARTEN';
export const UPDATE_OFFICIAL_SETTING = 'UPDATE_OFFICIAL_SETTING';